import { tv } from 'tailwind-variants';

export const emergencyAlertVariants = tv({
  slots: {
    alertWrapper: ['flex items-center justify-center gap-4 py-4 px-4', 'text-white'],
    contentWrapper: [
      'flex items-center justify-items-start gap-2 md:gap-4',
      'max-w-300 w-full',
      'flex-wrap sm:flex-nowrap',
    ],
    iconWrapper: ['shrink-0', 'flex items-center justify-center', 'w-12 h-12', 'hidden', 'md:flex'],
    icon: ['text-[36px]'],
    textContent: ['flex flex-col gap-1', 'text-left'],
    headline: ['text-lg leading-7.5 font-bold'],
    description: [
      // Target <p> and <li> rendered by RTE — utilities (@layer utilities) beat .rte p (@layer base)
      '[&_p]:text-lg',
      '[&_p]:font-light',
      '[&_p]:leading-6.75',
      '[&_p]:mb-0',
      '[&_p]:text-inherit',
    ],
    alertLink: [
      'underline hover:no-underline',
      'focus:outline focus:outline-2 focus:outline-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2',
      'text-lg leading-7.5',
      'inline-block',
      'font-medium',
      'max-w-fit',
    ],
    closeButton: [
      'shrink-0',
      'flex items-center justify-center',
      'w-8 h-8',
      'bg-transparent border-0',
      'text-white cursor-pointer',
      'hover:opacity-80 focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-transparent',
      'rounded-sm',
      'ml-auto',
    ],
    closeIcon: ['text-xl'],
  },
  variants: {
    alertType: {
      emergency: {
        alertWrapper: [],
      },
      neutral: {
        alertWrapper: [],
      },
    },
  },
  defaultVariants: {
    alertType: 'emergency',
  },
});
